
export const ACTIVE_PAGE_UPDATED 				= 'ACTIVE_PAGE_UPDATED';

// Pages
export const LANDING        	  				= 'LANDING';
export const ABOUT_SCROLL        	  			= 'ABOUT_SCROLL';
export const ABOUT_VIDEO_SLIDE_PLAY_TOGGLE      = 'ABOUT_VIDEO_SLIDE_PLAY_TOGGLE';
export const ABOUT_VIDEO_SLIDE_MUTE_TOGGLE      = 'ABOUT_VIDEO_SLIDE_MUTE_TOGGLE';
export const NEWS_ARTICLE_CLICK     			= 'NEWS_ARTICLE_CLICK';
export const FUTURE_RELEASE_DATE_CLICK	 		= 'FUTURE_RELEASE_DATE_CLICK';

// Menu
export const HEADER_PERSISTENT_BUTTON_CLICK 	= 'HEADER_PERSISTENT_BUTTON_CLICK';

// Landing - Hero
export const HERO_BUTTON_CLICK 					= 'HERO_BUTTON_CLICK';
export const HERO_MOVIE_SELECTION_TAB_CLICK 	= 'HERO_MOVIE_SELECTION_TAB_CLICK';
export const HERO_TAB_DIRECTION_CLICK 			= 'HERO_TAB_DIRECTION_CLICK';
export const HERO_VIDEO_SLIDE_PLAY_TOGGLE 		= 'HERO_VIDEO_SLIDE_PLAY_TOGGLE';

// Carousel
export const CAROUSEL_TOUT_CLICK 				= 'CAROUSEL_TOUT_CLICK';
export const CAROUSEL_BUTTON_CLICK 				= 'CAROUSEL_BUTTON_CLICK';
export const CAROUSEL_TAB_DIRECTION_CLICK 		= 'CAROUSEL_TAB_DIRECTION_CLICK';

export const MOVIELINK_TITLE_LINK_CLICK 		= 'MOVIELINK_TITLE_LINK_CLICK';

// Trailers
export const STUDIO_YOUTUBE_CHANNEL_CLICK 		= 'STUDIO_YOUTUBE_CHANNEL_CLICK';
export const TRAILERS_TAB_DIRECTION_CLICK 		= 'TRAILERS_TAB_DIRECTION_CLICK';
export const TRAILERS_TOUT_CLICK 				= 'TRAILERS_TOUT_CLICK';
export const TRAILER_MORE_INFO_CLICK 			= 'TRAILER_MORE_INFO_CLICK';

// Promo Touts
export const PROMO_TOUT_CLICK 					= 'PROMO_TOUT_CLICK';
export const PROMO_VIDEO_SLIDE_PLAY_TOGGLE 		= 'PROMO_VIDEO_SLIDE_PLAY_TOGGLE';

// Newsletter
export const FORM_SUBMIT_CLICK 					= 'FORM_SUBMIT_CLICK';




// Social Events
export const CLICKED_FOLLOW        				= 'CLICKED_FOLLOW';

// Footer
export const FOOTER_NAV_CLICK 					= 'FOOTER_NAV_CLICK';
export const FOOTER_PERSISTENT_BUTTON_CLICK 	= 'FOOTER_PERSISTENT_BUTTON_CLICK';
export const FOOTER_LEGAL_CLICK 				= 'FOOTER_LEGAL_CLICK';